import { createSlice } from '@reduxjs/toolkit'
import { LeadStateModel } from 'models/LeadStateModel'
import { SsoLoginInternal } from 'models/LoginResponseModel'
import { TokenHeaderModel } from 'models/TokenHeaderModel'
import { consoleLog } from 'utils/Logger'
import { deleteCookie, getCookie, setCookie } from 'utils/cokie'
import jwt_decode from 'jwt-decode'
import { getApolloAuthClient } from 'graphql/client'
import { REFRESH_TOKEN } from 'graphql/mutation'
import routes from 'routes'
import { Pages } from 'routes/types'
import { getCurrentDate } from 'utils/dateutil'
import moment from 'moment'

const tokenHEader = (() => {
  try {
    const token = getCookie('access_token')
    return token && token !== 'null' ? (jwt_decode(token) as TokenHeaderModel) : null
  } catch {
    return null
  }
})()
const isToken = Boolean(tokenHEader)
const reporteesId = getCookie('reportee_emp_ids')?.split(',')

export type InitialState = {
  isLoggedIn: boolean
  LoginData: SsoLoginInternal
  leadState: LeadStateModel
  tokenHeader: TokenHeaderModel
  reporteeEmpIds: string[] | undefined
}
const initialState = {
  isLoggedIn: isToken,
  isApiInProgress: false,
  LoginData: {},
  leadState: null,
  tokenHeader: tokenHEader,
  reporteeEmpIds: reporteesId,
} as InitialState

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    getLogin: (state, action) => {
      consoleLog(action?.payload)
      if (action?.payload) {
        state.LoginData = action.payload.ssoLoginInternal
      }
      if (action?.payload?.ssoLoginInternal?.refreshToken?.token != null) {
        state.isLoggedIn = true
        setCookie({
          name: 'refresh_token',
          value: action?.payload?.ssoLoginInternal.refreshToken?.token,
          expiryDays: 30,
        })
        setCookie({
          name: 'access_token',
          value: action?.payload?.ssoLoginInternal.accessToken?.token,
          expiryDays: 15,
        })
        setCookie({
          name: 'sf_token',
          value: action?.payload?.ssoLoginInternal.salesForceAccessToken?.token,
          expiryDays: 30,
        })
        const decoded = jwt_decode(
          action?.payload?.ssoLoginInternal?.accessToken?.token,
        ) as TokenHeaderModel
        state.tokenHeader = decoded
        state.reporteeEmpIds = decoded?.reporteeEmpIds
        setCookie({
          name: 'emp_id',
          value: decoded?.employeeid,
          expiryDays: 30,
        })

        setCookie({
          name: 'user_type',
          value: decoded?.userType,
          expiryDays: 30,
        })
        setCookie({
          name: 'emp_name',
          value: decoded?.ownername,
          expiryDays: 30,
        })
        setCookie({
          name: 'location_id',
          value: decoded?.locationId,
          expiryDays: 30,
        })
        setCookie({
          name: 'iat',
          value: decoded?.iat,
          expiryDays: 30,
        })
        setCookie({
          name: 'reportee_emp_ids',
          value: decoded?.reporteeEmpIds?.join(','),
          expiryDays: 30,
        })
        setCookie({
          name: 'internalCoordinatorId',
          value: decoded?.internalCoordinatorId,
          expiryDays: 30,
        })
      }
    },

    loginError: (state, action) => {
      state.isLoggedIn = false
      consoleLog('inside login error')
      deleteCookie({ name: 'refresh_token' })
      deleteCookie({ name: 'access_token' })
      deleteCookie({ name: 'sf_token' })
      deleteCookie({ name: 'emp_id' })
      deleteCookie({ name: 'emp_name' })
      deleteCookie({ name: 'user_type' })
      deleteCookie({ name: 'location_id' })
      deleteCookie({ name: 'iat' })
      deleteCookie({ name: 'reportee_emp_ids' })
      deleteCookie({ name: 'internalCoordinatorId' })
      localStorage.removeItem('timerEntries')

      state.tokenHeader = null
    },
    leadStateData: (state, action) => {
      state.leadState = action.payload
    },

    // getLogout: (state, action) => {
    //   if (action?.payload?.token) {
    //     state.isLoggedIn = false
    //     state.isValidatedToken = false
    //     state.errorMessage = ''
    //   }
    // },
  },
})

/*
We have to check if day is changed then we want to logout user forcefully
*/
export const checkLoginSession = () => async (dispatch) => {
  try {
    const iat = getCookie('iat')
    const currentDate = getCurrentDate()
    const formattedDate = moment(+iat * 1000).format('YYYY-MM-DD')
    if (formattedDate !== currentDate) {
      dispatch(loginError(null))
    }
  } catch (err) {
    consoleLog('njvj error display' + err)
  }
}

export const getAccessTokenNoDispatch = () => {
  return getApolloAuthClient()
    .mutate({
      mutation: REFRESH_TOKEN,
      variables: {
        input: {
          refreshToken: { token: getCookie('refresh_token') },
        },
      },
      context: { isAuthRequired: false },
    })
    .then((response) => {
      // extract your accessToken from your response data and return it
      consoleLog('inside the token refresh response')
      consoleLog('inside the token refresh response=' + response)

      const accessToken = response.data?.ssoLoginInternal?.accessToken?.token
      const refreshToken = response.data?.ssoLoginInternal?.refreshToken?.token

      setCookie({
        name: 'refresh_token',
        value: refreshToken,
        expiryDays: 30,
      })
      setCookie({
        name: 'access_token',
        value: accessToken,
        expiryDays: 15,
      })
      setCookie({
        name: 'sf_token',
        value: response.data?.ssoLoginInternal.salesForceAccessToken?.token,
        expiryDays: 30,
      })
      setCookie({
        name: 'iat',
        value: response.data?.ssoLoginInternal.salesForceAccessToken?.token,
        expiryDays: 30,
      })
      return { accessToken, refreshToken }
    })
}
export const getAccessToken = (dispatch) => {
  return getApolloAuthClient()
    .mutate({
      mutation: REFRESH_TOKEN,
      variables: {
        input: {
          refreshToken: { token: getCookie('refresh_token') },
        },
      },
      context: { isAuthRequired: false },
    })
    .then((response) => {
      // extract your accessToken from your response data and return it
      consoleLog('inside the token refresh response')
      consoleLog('inside the token refresh response=' + response)

      const accessToken = response.data?.ssoLoginInternal?.accessToken?.token
      const refreshToken = response.data?.ssoLoginInternal?.refreshToken?.token

      dispatch(getLogin(response?.data))
      return { accessToken, refreshToken }
    })
}

export const getSalesforceToken = (dispatch, navigate) => {
  return getApolloAuthClient()
    .mutate({
      mutation: REFRESH_TOKEN,
      variables: {
        input: {
          refreshToken: { token: getCookie('refresh_token') },
        },
      },
      context: { isAuthRequired: false },
    })
    .then((response) => {
      const accessToken = response.data?.ssoLoginInternal?.accessToken?.token
      const refreshToken = response.data?.ssoLoginInternal?.refreshToken?.token
      dispatch(getLogin(response?.data))
      return { accessToken, refreshToken }
    })
    .catch((e) => {
      dispatch(loginError(null))
      setTimeout(() => {
        navigate(routes[Pages.Login].path)
      }, 1000)
    })
}
export const { getLogin, loginError, leadStateData } = authSlice.actions
export const auth = (state) => state.auth.isLoggedIn
export default authSlice.reducer
